import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Chip } from 'atoms/ui/Chip';
import { glossary } from 'lib/glossary';

const Tag = styled(Chip)`
  align-self: flex-start;
`;

export const NewTag = () => {
  return (
    <Tag color="brand" size="small">
      <FormattedMessage {...glossary.new} />
    </Tag>
  );
};
